import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { PersonPerWorkFront } from '@controlling/person-per-work-front/person-per-work-front';
import { MachinePerWorkFront } from '@controlling/machine-per-work-front/machine-per-work-front';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';
import { WorkFrontTypeService } from '../proxy/controlling/controllers/work-front-type.service';

FieldBuilder.setNamespace('Controlling');

export const WORKFRONT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WorkFront.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.WorkFront.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .build(),
  FieldBuilder
    .number('foremanId', 'Entity.WorkFront.Foreman')
    .build(),
  FieldBuilder
    .foreignKey('workFrontTypeId', 'Entity.WorkFrontType', WorkFrontTypeService)
    .displayFromNested('workFrontType.name')
    .sortBy('workFrontType.name')
    .build(),
  FieldBuilder
    .number('workFrontSize', 'Entity.WorkFront.WorkFrontSize')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .build(),
];

export const WORKFRONT_CONFIG = {
  entityName: 'WorkFront',
  localizationKey: 'Controlling::Entity.WorkFront',
  fields: WORKFRONT_FIELDS,
  permission: 'PlanningInventory.WorkFronts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'PersonPerWorkFront',
      foreignKeyField: 'workFrontId',
      localizationKey: 'Controlling::Entity.PersonPerWorkFront',
      component: PersonPerWorkFront,
    },
    {
      entityName: 'MachinePerWorkFront',
      foreignKeyField: 'workFrontId',
      localizationKey: 'Controlling::Entity.MachinePerWorkFront',
      component: MachinePerWorkFront,
    },
  ]
};
